export default __webpack_public_path__ + "static/media/git.4c119355.svg";